var $ = jQuery.noConflict();

$(window).on('load', function () {
    let method = 'front';
    if ($('body').hasClass('wp-admin'))
        method = 'wp-admin';

        var initializeBlock = function ($block) {
            const swipers = $('.block-card-slider');
            const swipersArrayCards = [];
            let counter = 0;
            let current = 0;

            swipers.each(function(){
                const index = $(this).index();

                const swiper = $('.card-swiper-container',$(this));
                swiper.addClass('card-swiper-container--' + index);

                const prev = $('.swiper-button-prev', $(this));
                prev.addClass('swiper-button-prev--' + index);
                const next = $('.swiper-button-next', $(this));
                next.addClass('swiper-button-next--' + index);

                swipersArrayCards[counter] = new Swiper('.card-swiper-container--' + index, {
                    slidesPerView: "auto",
                    //centeredSlides: true,
                    slidesPerSlide: 1,
                    speed: 400,
                    spaceBetween: 20,
                    initialSlide: 0,
                    resistanceRatio: 0,
                    navigation: {
                        nextEl: '.swiper-button-next--' + index,
                        prevEl: '.swiper-button-prev--' + index,
                    },
                    on: {
                        init: function(){
                            //setPosition();
                        },
                        slideChange: function () {
                        },
                        transitionEnd: function() {
                            const elementleft = $('.card-swiper-container--' + index + ' .swiper-slide').last().offset().left + $('.card-swiper-container--' + index + ' .swiper-slide').last().width();
                            if (elementleft <= $(window).width()) {
                                if (!$('.block-card-slider--sustainability').length) {
                                    $('.swiper-button-next--' + index).addClass('swiper-button-disabled');
                                    this.allowSlideNext = false;
                                }
                            } else {
                                if (!$('.block-card-slider--sustainability').length) {
                                    $('.swiper-button-next--' + index).removeClass('swiper-button-disabled');
                                    this.allowSlideNext = true;
                                }
                            }
                        }
                    },
                });

                counter++;
            });

            $('.swiper-button-next').on('click', function(e) {
                e.preventDefault();
                return false;
            });

            function setPosition(){
                const containerWidth    = $('.block-card-slider .card-swiper-container').width();
                const slideWidth        = $('.block-card-slider .swiper-wrapper .swiper-slide').width();
                const margin            = (containerWidth - slideWidth)/2;

                if ($('.block-card-slider--default .swiper-wrapper').length){
                    $('.block-card-slider--default .swiper-wrapper').css('margin-left','-' + (margin - 25) + 'px');
                }
                if ($('.block-card-slider--sustainability .swiper-wrapper').length){
                    if ($(window).width() > 767){
                        $('.block-card-slider--sustainability .swiper-wrapper').css('margin-left','-' + (margin - 50) + 'px');
                    } else {
                        $('.block-card-slider--sustainability .swiper-wrapper').css('margin-left','-' + (margin - 22) + 'px');
                    }
                }
            }
            $(window).on('resize',function(){
                //setPosition();
            });
    };

    window.onload = function () {
        initializeBlock($(this));
    }();

    if (window.acf) {
        window.acf.addAction('render_block_preview/type=card-slider', initializeBlock);
    }
});
